import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions/chat';
import SearchingForAgent from 'components/chat/SearchingForAgent';


export default connect(
  state => ({
    title: state.chat.main.queueProperties.searchingForAvailabelAgentMessage,
    queuePosition: state.chat.main.queuePosition,
    stoppedWaiting: state.chat.main.stoppedWaiting,
    routingTimedOut: state.chat.main.routingTimedOut,
    showQueuePosition: state.chat.main.queueProperties.showQueuePosition,
    queuePositionMessage: state.chat.main.queueProperties.queuePositionMessage,
    timeoutMessage: state.chat.main.queueProperties.timeoutMessage,
    offeringToKeepWaiting:  state.chat.main.offeringToKeepWaiting,
    chatRequestId: state.chat.main.validationResult.chatRequestID,
    keepWaitingMessage: state.chat.main.queueProperties.keepWaitingMessage,
    stopWaitingMessage: state.chat.main.queueProperties.dontKeepWaitingMessage,
    isOutOfSchedule: state.chat.main.validationResult.isOutOfSchedule,
    outOfScheduleMessage: state.chat.main.queueProperties.outOfScheduleMessage,
  }),
  dispatch => bindActionCreators({
    onKeepWaiting: actions.keepWaiting,
    onStopWaiting: actions.stopWaiting,
  }, dispatch)
)(SearchingForAgent);



// WEBPACK FOOTER //
// ./containers/chat/SearchingForAgent.js